<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="success" icon="el-icon-document-checked" @click="tempDownload">
              엑셀
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="처리요청일자" label-width="100px">
                <el-row>
                  <el-col>
                    <el-col :span="11">
                      <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: start;">-</el-col>
                    <el-col :span="12">
                      <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="의뢰구분" label-width="100px">
                <el-select v-model="form.maType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="진행상태" label-width="100px">
                <el-select v-model="form.status">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['setupStatus']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="처리기사" label-width="100px">
                <el-select v-model="form.userId" >
                  <el-option value='0' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['agentUser']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked" />
            <ag-grid-vue
                ref="gridTemp"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnTemp"
                :grid-options="tempGridOptions"
                :row-data="data"
                :default-col-def="defaultColTemp"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                v-show="false"
                />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import BsMaTreat from "@/components/AS/BsmaList/BsMaTreat";

function _phone(hp){
  return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  props: {
  },
  data() {
    return {
      data: [],
      tempData:[],
      form: {
        companyId : '',
        startDt: this.$moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        // endDt: '',
        confirmYn : '',
        squareType : '',
        asAgentId : this.$store.state.loginInfo.asAgentId,
        // userId : this.$store.state.loginInfo.id,
        userId : '0',
        maType : '',
        status : '',
        catId : '',              // 지역
        sortType : '',           // 승인/정산처리유형
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'maType' : [],
        'setupStatus' : [],
        'agentUser' : []
      },
      //startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
      //endDt: this.$moment().format('YYYY-MM-DD'),
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 40px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
        resizable: true
        , filter:false
        , sortable: true
      },
      defaultColTemp: {
        resizable: true
        , filter:false
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      tempGridApi: null,
      tempColumnApi: null,
      tempGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      columnTemp: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.tempGridApi = this.tempGridOptions.api;
      this.tempColumnApi = this.tempGridOptions.columnApi;

      this.autoSizeAll(this.mainGridApi);
      this.init();
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    createMainColumnDefs() {

      const vm = this;

      this.columnDefs = [
        {headerName:'요청일자', field:'requestProcDt', width:110, cellStyle:{textAlign: 'center'} ,
          cellRenderer: (params) => {
            params.value = params.value === null  ? '' : vm.getDateFormat(`${params.value}`) ;
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }
        },
        {headerName:'처리기사', field:'userNm', cellStyle:{textAlign: 'center'}, width:160},
        {headerName:'의뢰구분', field:'maType', width:110, cellStyle:{textAlign: 'center'} },
        {
          headerName: '사이트명', children: [
            {headerName: '', field: 'siteNm1', width: 50, editable: false},
            {headerName: '', field: 'siteNm2', width: 50, editable: false},
            {headerName: '', field: 'siteNm3', width: 50, editable: false}
          ], width: 150, editable: false
        },
        {headerName:'고객명', field:'chargeNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'전화번호', field:'telNo', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'주소', field:'addr', width:120, cellStyle:{textAlign: 'center'}
        ,valueFormatter: (params) => {
            return params.data.addr1 + ' ' + params.data.addr2;
          }
        },
        {headerName:'모델', field:'modelNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'수량', field:'modelQty', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'작업내용', field:'workDetails', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'진행상태', field:'bsmaStatus', width:120, cellStyle:{textAlign: 'center'}
          ,valueFormatter: (params) => {
            return vm.typeSwitch(`${params.value}`);
          }
        },
        {headerName:'의뢰자', field:'requestNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'', field:'requestId', hide : true}
      ];

      this.columnTemp = [
        {headerName:'요청일자', field:'requestProcDt', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'처리기사', field:'userNm', cellStyle:{textAlign: 'center'}, width:160},
        {headerName:'구분', field:'maType', width:110, cellStyle:{textAlign: 'center'} },
        {headerName:'사이트명', field:'siteNm', width:200, cellStyle:{textAlign: 'center'}},
        {headerName:'고객명', field:'chargeNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'전화번호', field:'telNo', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'주소', field:'addr', width:200, cellStyle:{textAlign: 'center'}},
        {headerName:'모델', field:'modelNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'수량', field:'modelQty', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'작업내용', field:'workDetails', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'진행상태', field:'bsmaStatus', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'의뢰자', field:'requestNm', width:110, cellStyle:{textAlign: 'center'}},
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      if(field === 'requestProcDt') {
        const vForm = {
          companyId : this.form.companyId,
          mstType : 'Proc',
          requestId: params.data.requestId
        }
        this.$http.post(_url("/api/workMng/bsMaEdit/selectList"), vForm)
            .then(response => {
              // this.bsMaEditDetail = response.data;
              this.openModel(response.data);
              //this.bsMaEditDetail.data = response.data.uvwBsMaItemD

              // this.bsMaEditDetail.uvwBsMaItemM[0].siteTypeCombo = this.combos['siteType']
            }).finally(() => {
          this.$store.commit('finish')
        });
        // this.openModel(params.data);
      }
    },
    /**
     * 접수/처리 상세 팝업 오픈
     */
    openModel(param) {
      console.log(param);
      let vm = this;
      this.$modal.open({
        width: 800,
        component: BsMaTreat,
        parent: this,
        props: {
          data: param
        },
        events: {
          close(data) {
            console.log('close', data);
          },
        }
      });
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    typeSwitch(type){
      switch (type){
        case 'Confirm':
          return type ='승인';
        case 'Receipt':
          return type ='접수';
        case 'Complete':
          return type ='완료';
        case 'Square':
          return type ='정산';
      }
    },
    tempDownload(){
      this.tempGridOptions.api.exportDataAsExcel({fileName: 'BS/MA 처리리스트'});
    },
    goOpen() {
      let that = this
      this.$store.commit('loading')
      if(this.isEmpty(this.form.endDt) == '') this.form.endDt = '';
      this.$http.post(_url("/api/agent/bsMaAgent/list"), this.form).then(response => {
        this.data = response.data;

        // 엑셀 저장용으로 가공
        response.data.forEach(x=>{
          x.requestProcDt = x.requestProcDt !==null ? this.$moment(x.requestProcDt).format('YYYY-MM-DD') : '';
          x.siteNm = x.siteNm1 + ' ' + x.siteNm2 + ' ' + x.siteNm3;
          x.addr = x.addr1 + ' ' + x.addr2;
          x.bsmaStatus = this.typeSwitch(x.bsmaStatus);
          x.telNo = _phone(x.telNo);
        })
        this.tempData = response.data;
      }).finally(() => {
        this.$store.commit('finish')
        this.autoSizeAll(this.mainGridApi);
      });
    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/agent/bsMaAgent/init`)
          .then(response => {
            this.combos['maType'] = response.data.maType;
            this.combos['setupStatus'] = response.data.setupStatus;
            this.combos['agentUser'] = response.data.agentUser;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
    },
  },
  created() {

    if(this.$route.query.startDt == 'TodayComplete'){
      this.form.startDt = this.$moment().format('YYYY-MM-DD');
    }else if(this.$route.query.startDt == 'TodayWork'){
      this.form.startDt = '';
    }

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>